import { Button, Modal, Spin } from 'antd';
import React, { type CSSProperties, useState } from 'react';
import useSWR from 'swr';

import type { CleanKindResult } from '../sharedTypes';
import CleanKindEditor from './CleanKindEditor';
import {
  getCleanKindData,
  getSubscriptionPlanList,
  getTicketInfo,
} from './helper';
import styles from './index.module.scss';

type AddOrEditCleanKindProps = {
  type: 'add' | 'edit';
  getLatestData: () => void;
  record?: CleanKindResult;
};

const bodyStyles: CSSProperties = {
  maxHeight: '85vh',
  overflowY: 'scroll',
  padding: '24px 45px',
};

const AddOrEditCleanKind = ({
  type,
  getLatestData,
  record,
}: AddOrEditCleanKindProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { data: subscriptionPlanList, isLoading: isPlanFetcherLoading } =
    useSWR(
      '/ezcon/api/fetchSubscriptionPlansForCleanKind',
      getSubscriptionPlanList,
      {
        revalidateOnFocus: false,
      }
    );

  const { data: tickets, isLoading: isTicketFetcherLoading } = useSWR(
    '/ezcon/api/fetchTicketsForCleanKind',
    getTicketInfo,
    {
      revalidateOnFocus: false,
    }
  );

  const { data: cleanKindData, isLoading: isCleanKindFetcherLoading } = useSWR(
    '/ezcon/api/fetchCleanKind',
    async (url) => {
      if (type === 'edit') {
        const cleanKindData = await getCleanKindData(url, record?.cleanKindId);
        return cleanKindData;
      }
      return undefined;
    },
    {
      revalidateOnFocus: false,
    }
  );

  if (
    isPlanFetcherLoading ||
    isTicketFetcherLoading ||
    isCleanKindFetcherLoading
  ) {
    return (
      <div className={styles.loadingWrapper}>
        <Spin size="large" className={styles.loadingSpin} />
      </div>
    );
  }

  return (
    <>
      <Button onClick={() => setIsOpenModal(true)}>
        {type === 'add' ? '新增清潔類別' : '編輯'}
      </Button>
      <Modal
        title={type === 'add' ? '新增清潔類別' : '編輯清潔類別'}
        open={isOpenModal}
        centered
        destroyOnClose
        footer={null}
        bodyStyle={bodyStyles}
        width={1350}
        onCancel={() => setIsOpenModal(false)}
      >
        <CleanKindEditor
          type={type}
          closeModal={() => setIsOpenModal(false)}
          getLatestData={getLatestData}
          selectOptions={{ subscriptionPlanList, tickets }}
          record={record}
          cleanKindData={cleanKindData}
        />
      </Modal>
    </>
  );
};

export default AddOrEditCleanKind;
